// @flow

import _ from 'lodash';

import ko from 'rgs-knockout';

import {
	temporaryFileInfoToJSMap,
	temporaryFileInfoFromJSMap,
} from 'ko-extender-to-from-js-temporary-file-info';


const filesToJSMap = files => _(files)
	.filter(file => !_.isNil(ko.unwrap(file)) && !_.isEmpty(ko.unwrap(file)))
	.map(temporaryFileInfoToJSMap)
	.value();

const filesFromJSMap = filesJS => _.map(filesJS, temporaryFileInfoFromJSMap);

const filesToFromJSExtend = {
	toJSMap: filesToJSMap,
	fromJSMap: filesFromJSMap,
};

export {
	filesToJSMap,
	filesFromJSMap,
	filesToFromJSExtend,
};